<template>
    <div>
        <compWrapper
            :title="
                $t('global.common.base_information', {
                    defaultValue: '基本信息',
                })
            "
            theme="primary"
        >
            <compFormQuery
                v-if="type == 'query'"
                class="margin-top-15 margin-right-15"
                :formdata="getBase"
                :value="formData"
                :labelWidth="120"
            ></compFormQuery>
            <compFormEdit
                v-else
                class="margin-top-15 margin-right-15"
                ref="editform"
                :formdata="getBase"
                v-model="formData"
                :labelWidth="120"
            />
        </compWrapper>
        <compWrapper
            :title="$t('fbb.alloment.detail', { defaultValue: '详情' })"
            theme="info"
        >
            <compDetail
                class="margin-15"
                :opDetail="opDetail"
                :formtype="type"
                :querytype="querytype"
                ref="comdetail"
                :EnterissueId="EnterissueId"
            ></compDetail>
        </compWrapper>
        <compWrapper
            :title="
                $t('fbb.headlogistics.attachment', { defaultValue: '附件' })
            "
            theme="gray"
        >
            <div>
                <!-- 添加附件的弹框 -->
                <vButton
                    v-show="type != 'query'"
                    class="margin-20"
                    theme="primary"
                    @click="showupload"
                    >{{
                        $t("fbb.alloment.add_attachment", {
                            defaultValue: "添加附件",
                        })
                    }}</vButton
                >
                <!-- 附件的table -->
                <vTable
                    class="margin-left-20 margin-right-20"
                    :columns="columns"
                    :data="datalist"
                    size="small"
                    ref="table"
                    border
                ></vTable>
                <div
                    class="text-right margin-top-20 padding-right-20"
                    v-show="type != 'query'"
                >
                    <vButton theme="primary" @click="submit">{{
                        $t("global.common.update_OK", { defaultValue: "确定" })
                    }}</vButton>
                    <vButton class="margin-left-10" @click="cancel">{{
                        $t("global.common.operation_cancel", {
                            defaultValue: "取消",
                        })
                    }}</vButton>
                </div>
            </div>
        </compWrapper>

        <vModal
            class="hidefooter customerupload"
            v-model="operate.show"
            :title="operate.title"
            v-bind="operate"
        >
            <compUpload
                name="excelFile"
                :action="bossUrl + '/api/v2/serviceSummary/uploadAnnex'"
                v-if="operate.show"
                :title="operate.title"
                @on-success="aaasuccess"
                @on-cancel="cancelUpload"
            />
            <footer slot="footer" v-show="false"></footer>
        </vModal>
        <vLoading size="large" transfer :loading="loading"></vLoading>
    </div>
</template>
<script>
import { HttpVsSkuList } from "@/service/boss/allot";
import {
    HttpsaveOneSummary,
    HttpGetOneSummary,
    HttpGetFlagAndSku,
    HttpGetOrderNo,
} from "@/service/aftersales/aftersales";
import { mapState, mapGetters } from "vuex";
import compDetail from "./detail";
// import compLog from "./log"
import compUpload from "@components/templates/upload";
import orderTablelist from "../saleorders/orderTablelist";
export default {
    props: [
        "reasonid",
        "comorderno",
        "comerpsku",
        "comtype",
        "querytype",
        "activeids",
        "operacustype",
    ],
    components: {
        compWrapper: () => import("@components/templates/wrapper"),
        compFormQuery: () => import("@components/templates/formquery"),
        compFormEdit: () => import("@components/templates/formedit"),
        compDetail,
        compUpload,
        orderTablelist,
        // compLog,
    },
    data() {
        return {
            formData: {
                assignedTo: this.$store.state.userinfo.email,
                issueCategory: "POST_SALE_CONSULTING",
            },
            type: this.$route.params.type || this.querytype,
            custype: this.$route.query.custype || this.operacustype,
            id: this.$route.query.id || this.activeids,
            operate: {
                id: null,
                title: "",
                show: false,
                component: null,
            },
            bossUrl: process.env.VUE_APP_APIURL_BOSS,
            datalist: [],
            opDetail: [],
            loading: false,
            category: "POST_SALE_CONSULTING",
            issueTypes: {
                "": [],
                PRESALE_CONSULTING: [
                    { value: "DELIVERY", name: "Delivery" },
                    { value: "PAYMENT", name: "Payment" },
                    {
                        value: "PRODUCT_INFORMATION",
                        name: "Product Information",
                    },
                    { value: "COUPON_CODE", name: "Coupon Code" },
                    { value: "INVENTORY", name: "Inventory" },
                    {
                        value: "CUSTOMER_INQUIRY_FOR_PACKAGE",
                        name: "Customer Inquiry for Package",
                    },
                    {
                        value: "CUSTOMER_INQUIRY_FOR_COMPANY",
                        name: "Customer Inquiry for Company",
                    },
                    { value: "WARRANTY", name: "Warranty" },
                ],
                PURCHASING: [
                    { value: "SHIPPING_TIME", name: "Shipping time" },
                    { value: "CANCEL_ORDER", name: "Cancel order" },
                    { value: "CHANGE_ADDRESS", name: "Change address" },
                    {
                        value: "ORDER_INFORMATION_CONFIRM",
                        name: "Order information Confirm",
                    },
                    { value: "OUT_OF_STOCK", name: "Out of stock" },
                    { value: "NOT_RECEIVED", name: "Not received" },
                ],
                POST_SALE_CONSULTING: [
                    { value: "DOA", name: "DOA" },
                    {
                        value: "MISSING_PARTSORPARTS_DAMAGED",
                        name: "Missing parts/Parts damaged",
                    },
                    { value: "WRONG_DELIVERY", name: "Wrong Delivery" },
                    { value: "FBA_ISSUE", name: "FBA issue" },
                    { value: "BUYER_REMORSE", name: "Buyer Remorse" },
                    { value: "TROUBLE_SHOOTING", name: "Trouble Shooting" },
                    {
                        value: "QUALITY_ISSUE_NOT_AFFECT_USE",
                        name: "Quality Issue(Not affect use)",
                    },
                    {
                        value: "QUALITY_ISSUE_CAN_NOT_USE",
                        name: "Quality Issue(can not use)",
                    },
                    {
                        value: "PRODUCT_DOSE_NOT_MEET_CUSTOMER_EXPECTATION",
                        name: "Product Dose Not Meet Customer Expectation",
                    },
                ],
            },
            sellerSkulist: [],
            erpSkusList: [],
            EnterissueId: "",
        };
    },
    created() {
        console.log(this.id, this.custype);
        if (this.custype == "cus") {
            if (this.type == "add") return;

            this.getDetail(this.id);
        } else {
            if (this.reasonid != 0 && this.reasonid) {
                if (this.querytype == "query") {
                    this.type = this.querytype;
                }
                this.getAddcus();
                this.getDetail(this.reasonid);
            } else {
                this.getAddcus();
            }
        }
    },
    watch: {
        comorderno() {
            if (this.reasonid) {
                this.getDetail(this.reasonid);
            } else {
                this.getAddcus();
            }
        },
        comerpsku() {
            if (this.comtype == "add") {
                this.getAddcus();
            }
        },
    },
    computed: {
        // ...mapState('boss', ['products', 'accountTypes', 'accounts']),
        ...mapGetters("diction", ["getNewProductList", "getNewAccountList"]),
        // accountsAll() {
        // 	return this.getNewAccountList.sort(function (a, b) {
        // 		// console.log(a,b)
        // 		return a.value.localeCompare(b.value)
        // 	})
        // },
        getBase() {
            let showquery = this.type == "query" || this.custype != "cus";
            // console.log(showquery)
            return [
                {
                    label: this.$t("erp.b2c.channel_account", {
                        defaultValue: "渠道账号",
                    }),
                    key: "sourceChannel",
                    tag: "vSelect",
                    query: this.type == "query" || this.custype != "cus",
                    // show:this.type == 'query' || this.custype != 'cus',
                    options: this.getNewAccountList,
                    props: {
                        filterable: true,
                    },
                },
                {
                    label: this.$t("erp.b2c.search_ordernumber", {
                        defaultValue: "订单号",
                    }),
                    key: "orderNo",
                    required: false,
                    query: showquery,
                    children: (h) => {
                        return (
                            <vIcon
                                type="search"
                                center
                                slot="suffix"
                                style="padding:6px;pointer-events: initial;"
                                size="18"
                                nativeOnClick={this.handleModalplat.bind(this)}
                            />
                        );
                    },
                    props: {
                        readonly: true,
                    },
                },
                {
                    label: this.$t("global.common.project", {
                        defaultValue: "项目",
                    }),
                    key: "lineId",
                    tag: "vSelect",
                    query: showquery,
                    options: this.getNewProductList,
                    props: {
                        filterable: true,
                    },
                },
                {
                    label: this.$t("global.common.email", {
                        defaultValue: "邮箱",
                    }),
                    key: "orderEmail",
                    tag: "vInput",
                    required: false,
                    query: showquery,
                },

                {
                    label: "Seller SKU",
                    key: "sellerSku",
                    tag: "vInput",
                    required: false,
                    query: showquery,
                    on: {
                        "on-blur": (val) => {
                            // console.log(val)
                            this.getErpskuSellersku(val, "sellersku");
                        },
                    },
                },
                {
                    label: "ASIN",
                    key: "asin",
                    tag: "vInput",
                    required: false,
                    query: showquery,
                },
                {
                    label: "ERP SKU",
                    key: "erpSku",
                    tag: "vInput",
                    span: 24,
                    required: false,
                    query: showquery,
                    on: {
                        "on-blur": (val) => {
                            this.getErpskuSellersku(val, "erpsku");
                        },
                    },
                    formItem: {
                        style: "width:50%",
                    },
                },
                {
                    label: "Issue Category",
                    key: "issueCategory",
                    tag: "vSelect",
                    // query:showquery,
                    on: {
                        "on-change": (val) => {
                            this.category = val;
                        },
                    },
                    options: [
                        {
                            value: "PRESALE_CONSULTING",
                            label: "Presale Consulting",
                        },
                        {
                            value: "PURCHASING",
                            label: "Purchasing",
                        },
                        {
                            value: "POST_SALE_CONSULTING",
                            label: "Post-Sale Consulting",
                        },
                    ],
                    props: {
                        filterable: true,
                    },
                },
                {
                    label: "Issue Type",
                    key: "issueType",
                    tag: "vSelect",
                    // query:showquery,
                    options: this.issueTypes[this.category].map(function (
                        item
                    ) {
                        // console.log(item)
                        const { value, name } = item;
                        return {
                            value: value,
                            label: name,
                        };
                    }),
                    props: {
                        filterable: true,
                    },
                },
                {
                    label: "Source",
                    key: "source",
                    tag: "vRadio",
                    required: false,
                    show: this.type != "query",
                    valueText:
                        this.formData.orderOnlyShow == "0" ? "Email" : "Phone",
                    props: {
                        strict: false,
                    },
                    options: [
                        {
                            trueValue: "0",
                            label: "Email",
                        },
                        {
                            trueValue: "1",
                            label: "Phone",
                        },
                    ],
                },
                {
                    label: "Source",
                    key: "source",
                    show: this.type == "query",
                    valueText: this.formData.source == "0" ? "Email" : "Phone",
                },
                {
                    label: "Parts Name",
                    key: "partsName",
                    tag: "vInput",
                    show:
                        this.formData.issueType ==
                        "MISSING_PARTSORPARTS_DAMAGED",
                    // query:showquery,
                },
                {
                    label: "Email",
                    key: "sourceEmail",
                    tag: "vInput",
                    required: false,
                    // query:showquery,
                },
                {
                    label: "Phone",
                    key: "sourcePhone",
                    tag: "vInput",
                    required: false,
                    query: showquery,
                },
                {
                    label: "AssignedTo",
                    key: "assignedTo",
                    tag: "vInput",
                    // query:showquery,
                },
                {
                    label: "Issue Status",
                    key: "issueStatus",
                    tag: "vSelect",
                    // query:showquery,
                    options: [
                        {
                            value: "INPROCESS",
                            label: "Inprogress ",
                        },
                        {
                            value: "FINISHED",
                            label: "Done",
                        },
                    ],
                    props: {
                        filterable: true,
                        readonly: this.custype != "cus",
                    },
                },
            ];
        },
        columns() {
            let _this = this;
            return [
                {
                    title: this.$t("global.common.attachment_name", {
                        defaultValue: "附件名称",
                    }),
                    key: "fileName",
                },
                {
                    title: this.$t("global.common.attachment_url", {
                        defaultValue: "附件链接",
                    }),
                    render(h, { row }) {
                        return <a>{row.fileUrl}</a>;
                    },
                },
                {
                    title: this.$t("global.common.attachment_url", {
                        defaultValue: "附件链接",
                    }),
                    key: "filepath",
                },
                {
                    title: this.$t("global.common.actions", {
                        defaultValue: "操作",
                    }),
                    width: 120,
                    render(h, { row, index }) {
                        return h("div", [
                            h(
                                "Button",
                                {
                                    props: {
                                        type: "error",
                                        size: "small",
                                    },
                                    on: {
                                        click: () => {
                                            _this.remove(index);
                                        },
                                    },
                                },
                                this.$t("global.common.delete", {
                                    defaultValue: "删除",
                                })
                            ),
                        ]);
                    },
                },
            ];
        },
    },
    methods: {
        getAddcus() {
            let salesdata = sessionStorage.get("salesdata");
            let item = JSON.parse(salesdata);
            let {
                erpSku,
                sellerSku,
                lineId,
                sourceChannel,
                orderNo,
                orderEmail,
                asin,
                issueStatus,
                sourcePhone,
            } = item;
            this.formData = {
                erpSku,
                sellerSku,
                lineId,
                sourceChannel,
                orderNo,
                orderEmail,
                asin,
                issueStatus,
                sourcePhone,
            };
            this.formData.assignedTo = this.$store.state.userinfo.email;
            this.formData.issueCategory = "POST_SALE_CONSULTING";
            // this.category = 'POST_SALE_CONSULTING'
            // console.log(item.dataindex)
            let ary = sessionStorage.get("custupdate");
            // console.log(ary)
            if (ary && ary != "null") {
                // console.log(112344)
                let custerDetail = JSON.parse(ary);
                this.formData.issueCategory =
                    custerDetail.serviceSummaryBaseInfo.issueCategory;
                this.formData.issueType =
                    custerDetail.serviceSummaryBaseInfo.issueType;
                this.formData.sourceEmail =
                    custerDetail.serviceSummaryBaseInfo.sourceEmail;
                this.formData.assignedTo =
                    custerDetail.serviceSummaryBaseInfo.assignedTo;
                this.formData.partsName =
                    custerDetail.serviceSummaryBaseInfo.partsName;
            }
        },
        getDetail(id) {
            this.loading = true;
            HttpGetOneSummary({
                id: id,
            })
                .then((res) => {
                    this.formData = res.data.serviceSummaryBaseInfo;
                    this.category =
                        res.data.serviceSummaryBaseInfo.issueCategory;
                    this.opDetail = res.data.serviceSummaryItemList;
                    this.datalist = res.data.serviceSummaryAnnexList || [];
                    this.EnterissueId = res.data.issueId;
                })
                .finally((res) => {
                    this.loading = false;
                    // this.formData.assignedTo = this.$store.state.userinfo.email
                });
        },
        showupload() {
            this.operate = {
                show: true,
                title: this.$t("fbb.alloment.add_attachment", {
                    defaultValue: "添加附件",
                }),
            };
        },
        aaasuccess(res) {
            let data = {
                fileName: res.data.fileName,
                fileUrl: res.data.fileUrl,
                filepath: res.data.filepath,
            };
            this.datalist.push(data);
        },
        remove(index) {
            this.datalist.splice(index, 1);
        },
        cancelUpload() {
            this.operate.show = false;
        },
        // 搜索sellerSku列表
        HttpGetErpsku(query) {
            HttpGetFlagAndSku({
                accountFlag: this.formData.sourceChannel,
                sellerSku: this.formData.sellerSku,
            }).then(
                (res) => {
                    this.sellerSkulist = res.data;
                },
                (err) => {
                    this.$VMessage.error({
                        content: err.message,
                        duration: 30,
                        closable: true,
                    });
                }
            );
        },
        getErpskuSellersku(val, type) {
            if (type == "sellersku") {
                HttpGetFlagAndSku({
                    accountFlag: this.formData.sourceChannel,
                    sellerSku: val,
                }).then(
                    (res) => {
                        this.formData.asin = res.data.asin;
                        this.formData.erpSku = res.data.erpSku;
                        this.formData.sellerSku = res.data.sellerSku;
                    },
                    (err) => {
                        this.$VMessage.error({
                            content: err.message,
                            duration: 30,
                            closable: true,
                        });
                    }
                );
            } else {
                HttpGetFlagAndSku({
                    accountFlag: this.formData.sourceChannel,
                    erpSku: val,
                }).then(
                    (res) => {
                        this.formData.asin = res.data.asin;
                        this.formData.erpSku = res.data.erpSku;
                        this.formData.sellerSku = res.data.sellerSku;
                    },
                    (err) => {
                        this.$VMessage.error({
                            content: err.message,
                            duration: 30,
                            closable: true,
                        });
                    }
                );
            }
        },
        async submit() {
            // console.log(11111)
            const valid = await this.$refs["editform"].validate();
            if (!valid) return;

            // if(this.formData.sourceEmail == '' && this.formData.sourcePhone == ''){
            //     this.$Message.error('Email 和 Phone 不能同时为空！');
            //     return
            // }

            if (!this.formData.orderNo && !this.formData.orderEmail) {
                this.$Message.error(
                    this.$t("erp.aftersales.orderemail", {
                        defaultValue: "订单号 和 邮箱 不能同时为空！",
                    })
                );
                return;
            }

            if (this.$refs.comdetail.formData.issueId == "") {
                this.$Message.error(
                    this.$t("erp.aftersales.writeissue", {
                        defaultValue: "请填写issue ID",
                    })
                );
                return;
            }
            if (
                this.$refs.comdetail.datalist[0].issueDescription == "" &&
                this.$refs.comdetail.datalist[0].followUp == ""
            ) {
                this.$Message.error(
                    this.$t("erp.aftersales.writetable", {
                        defaultValue: "请填写table中的数据",
                    })
                );
                return;
            }
            let comcustype = sessionStorage.get("comcustype");
            // console.log(this.$refs.comdetail)

            // 添加售后单原因的步骤
            let cusdata = {
                serviceSummaryBaseInfo: this.formData,
                issueId: this.$refs.comdetail.formData.issueId,
                serviceSummaryItemList: this.$refs.comdetail.datalist,
                serviceSummaryAnnexList: this.datalist,
            };
            // console.log(cusdata)
            sessionStorage.set("custupdate", JSON.stringify(cusdata));

            if (comcustype != "comcustype") {
                this.loading = true;
                await HttpGetFlagAndSku({
                    accountFlag: this.formData.sourceChannel,
                    sellerSku: this.formData.sellerSku,
                    erpSku: this.formData.erpSku,
                }).then(
                    (res) => {
                        this.formData.productId = res.data.productId;
                    },
                    (err) => {
                        this.errorMessage(err.message);
                    }
                );

                const response = await HttpsaveOneSummary({
                    serviceSummaryBaseInfo: this.formData,
                    issueId: this.$refs.comdetail.formData.issueId,
                    serviceSummaryItemList: this.$refs.comdetail.datalist,
                    serviceSummaryAnnexList: this.datalist,
                }).catch((err) => {
                    this.errorMessage(err.message);
                    this.loading = false;
                });
                if (response) {
                    if (this.custype == "cus") {
                        this.$Message.success(response.message);
                        this.$router.push({
                            name: "afterCustomer",
                        });
                    }
                }

                return this.$refs.comdetail.formData.issueId;
            } else {
                this.$emit("on-update", "closecom");
            }
        },
        cancel() {
            // 跳转到customer列表页面
            if (this.custype == "cus") {
                this.$router.push({
                    name: "afterCustomer",
                });
            } else {
                this.$emit("on-closeCus");
            }
        },
        handleModalplat() {
            this.$VModal.info({
                title: this.$t("erp.aftersales.submitorderno", {
                    defaultValue: "订单查询",
                }),
                width: 1000,
                showFooter: false,
                render: (h, props) => {
                    return this.$createElement("orderTablelist", {
                        props: {
                            products: this.getNewProductList,
                        },
                        on: {
                            rows: (rows) => {
                                // 请求单条 的接口

                                // 头部点击切换订单
                                this.getOrderNoList(
                                    rows.orderNo,
                                    rows.channelFlag
                                );
                                this.$VModal.destroy();
                            },
                            cancel: () => {
                                this.$VModal.destroy();
                            },
                        },
                    });
                },
            });
        },
        getOrderNoList(orderNo, channelFlag) {
            HttpGetOrderNo({
                orderNo: orderNo,
                sourceChannel: channelFlag,
            }).then(
                (res) => {
                    let { orderNo, sourceChannel, lineId, email, phone } =
                        res.data.orderServiceInfo.orderServiceBaseInfo;
                    this.$set(this.formData, "orderNo", orderNo);
                    this.$set(this.formData, "sourceChannel", sourceChannel);
                    this.$set(this.formData, "lineId", lineId);
                    this.$set(this.formData, "orderEmail", email);
                    this.$set(this.formData, "sourcePhone", phone);
                },
                (err) => {}
            );
        },
    },
};
</script>
